<div class="landing-page">
    <!-- tap on top starts-->
    <div class="tap-top"><i data-feather="chevrons-up"></i></div>
    <!-- tap on tap ends-->
    <!-- page-wrapper Start-->
    <div class="page-wrapper landing-page">
        <!-- Page Body Start            -->
        <div class="landing-homes">

            <div class="container-fluid">
                <div class="sticky-header">
                    <header>
                        <nav class="navbar navbar-b navbar-trans navbar-expand-xl fixed-top nav-padding" id="sidebar-menu">
                            <a class="navbar-brand p-0" href="#"><img class="img-fluid" src="{{layout.getLogo()}}" alt=""></a>
                            <button class="navbar-toggler navabr_btn-set custom_nav" type="button" data-bs-toggle="collapse" data-bs-target="#navbarDefault" aria-controls="navbarDefault" aria-expanded="false" aria-label="Toggle navigation"><span></span><span></span><span></span></button>
                            <div class="navbar-collapse justify-content-end collapse hidenav" id="navbarDefault">
                                <ul class="navbar-nav navbar_nav_modify" id="scroll-spy">
                                    <li class="nav-item"><a class="nav-link text-black" href="landing/home#product">Produk</a></li>
                                    <li class="nav-item"><a class="nav-link" href="landing/home#documents">Dokumentasi</a></li>
                                    <li class="nav-item"><a class="nav-link" href="landing/home#faq">FAQ</a></li>
                                    <li class="nav-item"><a class="nav-link" href="landing/about">Tentang Kami</a></li>
                                    <li class="nav-item"><a class="nav-link" href="landing/home#contact">Kontak</a></li>
                                    <li class="btn btn-sm btn-primary nav-item buy-btn"><a (click)="open(login)" class="nav-link js-scroll" style="color:#fff;">Login</a></li>
                                </ul>
                            </div>
                        </nav>
                    </header>
                </div>

            </div>
        </div>

        <section class="section-space cuba-demo-section bg-Widget p-b-150 bg-primary" id="about">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 wow pulse">
                        <div class="cuba-demo-content p-b-100 m-t-50 m-b-150">
                            <div class="couting">
                                <h1>FAQ</h1>
                            </div>
                            <p style="padding:100px;">
                                Semua yang ingin anda ketahui tentang produk {{layout.getTenant()}} API.<br /> Belum menemukan jawaban yang anda cari?<br /> silakan ajukan pertanyaan ke tim kami.<br />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-space cuba-demo-section" id="faq">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 wow pulse">
                        <div class="cuba-demo-content mt50">
                            <div class="couting">
                                <h2>FAQ</h2>
                            </div>
                            <p>Temukan API {{layout.getTenant()}} yang Sesuai dengan Kebutuhan Bisnismu.</p>
                        </div>
                    </div>
                </div>

                <div class="row default-according style-1 faq-accordion">
                    <div class="col-sm-12 m-b-20">
                        <div class="card">
                            <ngb-accordion #acc="ngbAccordion" [closeOthers]="true" activeIds="ngb-panel-1">
                                <ngb-panel>
                                    <ng-template ngbPanelTitle>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12" y2="17"></line></svg>                                        Adakah dokumentasi API {{layout.getTenant()}} dapat digunakan sebagai panduan teknis integrasi API {{layout.getTenant()}}?</ng-template>
                                    <ng-template ngbPanelContent>
                                        {{layout.getTenant()}} menyediakan Dokumentasi API {{layout.getTenant()}} yang bisa didapatkan di www.developer.bankkalabar.co.id dan dapat digunakan sebagai panduan integrasi dengan API {{layout.getTenant()}}.
                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
                        </div>
                    </div>

                    <div class="col-sm-12 m-b-20">
                        <div class="card">
                            <ngb-accordion #acc="ngbAccordion" [closeOthers]="true" activeIds="ngb-panel-0">
                                <ngb-panel>
                                    <ng-template ngbPanelTitle>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12" y2="17"></line></svg>                                        Apakah fitur Sandbox API {{layout.getTenant()}} berbayar?</ng-template>
                                    <ng-template ngbPanelContent>
                                        Akses Sandbox API {{layout.getTenant()}} tidak dikenakan biaya apapun
                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
                        </div>
                    </div>

                    <div class="col-sm-12 m-b-20">
                        <div class="card">
                            <ngb-accordion #acc="ngbAccordion" [closeOthers]="true" activeIds="ngb-panel-1">
                                <ngb-panel>
                                    <ng-template ngbPanelTitle>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12" y2="17"></line></svg>                                        Bagaimana cara melakukan Telnet ke sistem API {{layout.getTenant()}}?</ng-template>
                                    <ng-template ngbPanelContent>
                                        Cara melakukan Telnet ke server developer API {{layout.getTenant()}}:<br/> 1. Buka 'Command Prompt'<br/> 2. Ketik command untuk telnet (contoh: telnet devapi.bankkalbar.com 443) atau bisa disesuaikan dengan command yang sesuai
                                        dengan sistem masing-masing copartner.
                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
                        </div>
                    </div>

                    <div class="col-sm-12 m-b-20">
                        <div class="card">
                            <ngb-accordion #acc="ngbAccordion" [closeOthers]="true" activeIds="ngb-panel-0">
                                <ngb-panel>
                                    <ng-template ngbPanelTitle>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12" y2="17"></line></svg>Bagaimana
                                        cara mendapatkan access token?</ng-template>
                                    <ng-template ngbPanelContent>
                                        Gunakan fitur Utilities yang ada di dalam My APIs (pastikan sudah login akun) untuk bisa mendapatkan access token dari proses Oauth.
                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
                        </div>
                    </div>

                    <div class="col-sm-12 m-b-20">
                        <div class="card">
                            <ngb-accordion #acc="ngbAccordion" [closeOthers]="true" activeIds="ngb-panel-1">
                                <ngb-panel>
                                    <ng-template ngbPanelTitle>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12" y2="17"></line></svg>Bagaimana
                                        cara mendapatkan access token?</ng-template>
                                    <ng-template ngbPanelContent>
                                        Gunakan fitur Utilities yang ada di dalam My APIs (pastikan sudah login akun) untuk bisa mendapatkan access token dari proses Oauth.
                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
                        </div>
                    </div>

                    <div class="col-sm-12 m-b-20">
                        <div class="card">
                            <ngb-accordion #acc="ngbAccordion" [closeOthers]="true" activeIds="ngb-panel-1">
                                <ngb-panel>
                                    <ng-template ngbPanelTitle>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12" y2="17"></line></svg>                                        Adakah dokumentasi API {{layout.getTenant()}} dapat digunakan sebagai panduan teknis integrasi API {{layout.getTenant()}}?</ng-template>
                                    <ng-template ngbPanelContent>
                                        {{layout.getTenant()}} menyediakan Dokumentasi API {{layout.getTenant()}} yang bisa didapatkan di www.developer.bankkalabar.co.id dan dapat digunakan sebagai panduan integrasi dengan API {{layout.getTenant()}}.
                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
                        </div>
                    </div>

                    <div class="col-sm-12 m-b-20">
                        <div class="card">
                            <ngb-accordion #acc="ngbAccordion" [closeOthers]="true" activeIds="ngb-panel-0">
                                <ngb-panel>
                                    <ng-template ngbPanelTitle>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12" y2="17"></line></svg>                                        Apakah fitur Sandbox API {{layout.getTenant()}} berbayar?</ng-template>
                                    <ng-template ngbPanelContent>
                                        Akses Sandbox API {{layout.getTenant()}} tidak dikenakan biaya apapun
                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
                        </div>
                    </div>

                    <div class="col-sm-12 m-b-20">
                        <div class="card">
                            <ngb-accordion #acc="ngbAccordion" [closeOthers]="true" activeIds="ngb-panel-1">
                                <ngb-panel>
                                    <ng-template ngbPanelTitle>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12" y2="17"></line></svg>                                        Bagaimana cara melakukan Telnet ke sistem API {{layout.getTenant()}}?</ng-template>
                                    <ng-template ngbPanelContent>
                                        Cara melakukan Telnet ke server developer API {{layout.getTenant()}}:<br/> 1. Buka 'Command Prompt'<br/> 2. Ketik command untuk telnet (contoh: telnet devapi.bankkalbar.com 443) atau bisa disesuaikan dengan command yang sesuai
                                        dengan sistem masing-masing copartner.
                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
                        </div>
                    </div>

                    <div class="col-sm-12 m-b-20">
                        <div class="card">
                            <ngb-accordion #acc="ngbAccordion" [closeOthers]="true" activeIds="ngb-panel-0">
                                <ngb-panel>
                                    <ng-template ngbPanelTitle>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12" y2="17"></line></svg>Bagaimana
                                        cara mendapatkan access token?</ng-template>
                                    <ng-template ngbPanelContent>
                                        Gunakan fitur Utilities yang ada di dalam My APIs (pastikan sudah login akun) untuk bisa mendapatkan access token dari proses Oauth.
                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
                        </div>
                    </div>

                    <div class="col-sm-12 m-b-20">
                        <div class="card">
                            <ngb-accordion #acc="ngbAccordion" [closeOthers]="true" activeIds="ngb-panel-1">
                                <ngb-panel>
                                    <ng-template ngbPanelTitle>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12" y2="17"></line></svg>Bagaimana
                                        cara mendapatkan access token?</ng-template>
                                    <ng-template ngbPanelContent>
                                        Gunakan fitur Utilities yang ada di dalam My APIs (pastikan sudah login akun) untuk bisa mendapatkan access token dari proses Oauth.
                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <footer class="footer-bg" id="contact">
            <div class="container">
                <div class="landing-center ptb50">
                    <div class="title m-b-30"><img class="img-fluid" src="{{layout.getLogo()}}" alt="" width="250px"></div>
                    <div class="footer-content">
                        <p class="mb-4">{{layout.getTenant()}} API merupakan application programming interface (API) yang dikembangkan oleh {{layout.getTenant()}} pada tahun 2022 dan didukung oleh ratusan talenta IT terbaik guna mewujudkan integrasi perbankan yang aman dan mudah,ingin tahu
                            lebih banyah hubungi kami.</p>
                        <a class="btn mrl5 btn-lg btn-primary default-view" (click)="openLg(contactme)"> <i data-feather="message-circle"> </i> Kontak Kami</a>
                        <a class="btn mrl5 btn-lg btn-secondary btn-md-res" (click)="openLg(register)"> <i data-feather="user"> </i> Daftar Sekarang!</a>
                    </div>
                </div>
            </div>
            <div class="section-space cuba-demo-section bg-Widget ptb50 bg-primary">
                <div class="container ">
                    <div class="row">
                        <div class="col-md-6 footer-first">
                            <div data-block-plugin-id="block_content:4aa4ecd7-0b53-4f6a-953e-6b376c113a66" class="block block--basic block--footer-third-2">
                                <div class="field field--hidden basic__body"><img class="logo-bri" src="{{layout.getLogo()}}" width="200px"></div>
                            </div>
                        </div>
                        <div class="col-md-5 footer-bottom" align="left">
                            <div class="field field--hidden basic__body">
                                <div class="address-footer" style="display:flex;">
                                    <p style="color: #FFFFFF; font-size: 12px;"><span style="font-size:14px"><b>{{layout.getTenant()}}</b><br><span style="color:white"> KANTOR PUSAT</span><br><br> {{layout.getAddress()}}<br> {{layout.getPhone()}}<br>{{layout.getFax()}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>

        <!-- Modal Login -->
        <ng-template #login let-modal>
            <div class="modal-header ">
                <h4 class="modal-title " id="modal-basic-title ">Masuk Aplikasi</h4>
                <button type="button " class="close " aria-label="Close " (click)="modal.dismiss( 'Cross click') ">
                <span aria-hidden="true ">&times;</span>
              </button>
            </div>
            <div class="modal-body">

                <div class="form-group">
                    <label class="col-form-label">Email Address</label>
                    <input class="form-control" type="email" required="" placeholder="Test@gmail.com">
                </div>
                <div class="form-group">
                    <label class="col-form-label">Password</label>
                    <div class="form-input position-relative">
                        <input class="form-control" type="password" name="login[password]" required="" placeholder="*********">
                        <div class="show-hide" style="top:18px;"><span class="show"></span>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row mt-2 mb-4">
                <div class="col-md-9 col-9"><label class="container col-form-label">Belum punya akun? <a (click)="openLg(register)">Registrasi di sini</a></label></div>
                <div class="col-md-2 col-2">
                    <div align="right" style="margin-left:-20px;">
                        <a href="dashboard/default" class="btn btn-primary" type="button">Login</a>
                    </div>
                </div>
            </div>
        </ng-template>
        <!-- Modal Login -->

        <!-- Modal Contact -->
        <ng-template #contactme let-modal>
            <div class="modal-header ">
                <h4 class="modal-title " id="modal-basic-title ">Silahkan Tanya Kami Disini</h4>
                <button type="button " class="close " aria-label="Close " (click)="modal.dismiss( 'Cross click') ">
                <span aria-hidden="true ">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <label class="col-form-label">Nama</label>
                    <input class="form-control" type="text" required="" placeholder="Nama">
                </div>
                <div class="form-group">
                    <label class="col-form-label">Kontak</label>
                    <input class="form-control" type="number" required="" placeholder="Kontak">
                </div>
                <div class="form-group">
                    <label class="col-form-label">Email</label>
                    <input class="form-control" type="email" required="" placeholder="Test@gmail.com">
                </div>
                <div class="form-group">
                    <label class="col-form-label">Pesan</label>
                    <textarea class="form-control" id="bm-desc" required="" autocomplete="off"></textarea>
                </div>

            </div>
            <div class="row mt-2 mb-4">
                <div class="col-md-2 col-2">
                    <div align="right" style="margin-left:-20px;">
                        <a href="dashboard/default" class="btn btn-primary" type="button">Kirim</a>
                    </div>
                </div>
            </div>
        </ng-template>
        <!-- Modal Contact -->

        <!-- Modal Register -->
        <ng-template #register let-modal>
            <div class="modal-header ">
                <h4 class="modal-title " id="modal-basic-title ">Daftar ke Website Developer API </h4>
                <button type="button " class="close " aria-label="Close " (click)="modal.dismiss( 'Cross click') ">
                <span aria-hidden="true ">&times;</span>
              </button>
            </div>
            <div class="modal-body">

                <div class="form-group">
                    <label class="col-form-label">Nama Lengkap</label>
                    <input class="form-control" type="text" required="" placeholder="Masukkan Namamu Disini">
                </div>
                <div class="form-group">
                    <label class="col-form-label">Email</label>
                    <input class="form-control" type="email" required="" placeholder="Masukkan Emailmu Disini">
                </div>
                <div class="form-group">
                    <label class="col-form-label">Kontak</label>
                    <input class="form-control" type="number" required="" placeholder="Masukkan Nomor Handphonemu Disini">
                </div>
                <div class="form-group">
                    <label class="col-form-label">Nama Perusahaan</label>
                    <input class="form-control" type="text" required="" placeholder="Masukkan Nama Perusahaan Disini">
                </div>

                <div class="form-group">
                    <label class="col-form-label">Kata Sandi</label>
                    <div class="form-input position-relative">
                        <input class="form-control" type="password" name="login[password]" required="" placeholder="*********">
                        <div class="show-hide" style="top:18px;"><span class="show"></span>
                        </div>

                        <div class="form-group">
                            <label class="col-form-label">Ulangi Kata Sandi</label>
                            <div class="form-input position-relative">
                                <input class="form-control" type="password" name="login[password]" required="" placeholder="*********">
                                <div class="show-hide" style="top:18px;"><span class="show"></span>
                                </div>

                            </div>
                        </div>

                    </div>
                    <div class="row mt-2 mb-4">
                        <div class="col-md-12 col-12">
                            <div align="right" style="margin-left:-20px;">
                                <button class="btn btn-primary" type="button" (click)="modal.close( 'Save click') ">Register</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </ng-template>
        <!-- Modal Register -->

    </div>